import {GET_CARS, GET_CARS_SUCCESS, UPDATE_CARS_PAGINATION,} from '../constants/Cars';

const initialState = {
  cars: [],
  search: '',
  perPage: 10,
  from: 0,
  to: 0,
  page: 1,
  loading: false,
};

const cars = (state = initialState, action) => {
  switch (action.type) {
    case GET_CARS:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
        loading: true,
      };
    case GET_CARS_SUCCESS:
      return {
        ...state,
        cars: action.cars,
        total: action.total,
        from: action.from,
        to: action.to,
        loading: false,
      };
    case UPDATE_CARS_PAGINATION:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
      };
    default:
      return state;
  }
};

export default cars;
